import { connect } from 'react-redux'

import { registerById, unregisterById, chooseActiveTabById, fetchPage } from './actions'
import { rootSelector, isInstanceCreated } from './selectors'
import { getOpenedPages } from '../OpenedPages'
import { memorizedParams } from './helpers'

// passing ID & hash from params would be modal case
const mapStateToProps = (state, { ID, hash, params }) => ({
  openedWindows: getOpenedPages(state),
  root: rootSelector(state),
  ID: ID || (params && params.ID),
  hash: hash || (params && params.hash),
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  register(type, ID) {
    return dispatch(registerById(type, ID))
  },

  unregister(type, ID) {
    if (ownProps.onClose) ownProps.onClose()

    return dispatch(unregisterById(type, ID))
  },

  fetchBase:
    ({ openedWindows, root }) =>
    (args) => {
      const { tabs, defaultTabId, baseTabId, location, openContext } = memorizedParams(ownProps)

      const uriToCheck = args.uri || location.pathname

      const queryParams = new URLSearchParams(location.search)
      const tabQuery = queryParams.get('tab')

      const tabItems = tabs()

      // TODO: refactor this shit
      const defaultTab =
        openContext !== 'modal' && tabQuery && tabItems[Object.keys(tabItems)[tabQuery - 1]]
          ? tabItems[Object.keys(tabItems)[tabQuery - 1]].name
          : defaultTabId

      // If instance of current detailsContainer is created
      // don't do stuff like fetching & changing tab
      if (openedWindows[uriToCheck] && isInstanceCreated(root, args)) return

      // If window is not in opened windows list
      // and there is key with given ID in store
      // client has entered uri by hand
      if (!openedWindows[uriToCheck] && isInstanceCreated(root, args)) {
        dispatch(unregisterById(args.type, args.ID))
      }

      if (defaultTab !== baseTabId) {
        const { api } = tabItems[baseTabId]

        if (Array.isArray(api)) {
          api.forEach((page) => {
            if (page === 'base') {
              dispatch(fetchPage({ ...args, page }))
            }
          })
        } else {
          dispatch(fetchPage({ ...args, page: api }))
        }
      }

      const tab = tabItems[defaultTab]

      dispatch(chooseActiveTabById({ ...args, tab, firstSwitch: true }))
    },
})

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...ownProps,
  ...stateProps,
  ...dispatchProps,
  fetchBase: dispatchProps.fetchBase(stateProps),
})

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)
